import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import React from 'react';

import { CircularProgress } from '@material-ui/core';

export class RemoteButton extends React.PureComponent {
    state = {
        showDialog: false,
        running: false,
    };

    componentWillUnmount() {
        this.distroyed = true;
    }

    closeDialog = () => {
        this.setState({ showDialog: false });
    }

    showDialog = () => {
        this.setState({ showDialog: true });
    }

    start = async () => {
        this.setState({ running: true });
        await this.props.onStart();
        if (this.distroyed) {
            return;
        }
        this.setState({ running: false, showDialog: false });
    }

    render() {
        return (
            <div style={{ display: 'inline' }}>
                <Dialog open={this.state.showDialog} onClose={this.closeDialog}>
                    <DialogTitle>{this.props.title || this.props.name}</DialogTitle>
                    <DialogContent>
                        {this.props.children}
                    </DialogContent>
                    <DialogActions>
                        {
                            this.state.running &&
                            <CircularProgress />
                        }
                        {
                            !this.state.running &&
                            <div>
                                <Button variant="contained" onClick={this.closeDialog}>Cancel</Button>
                                <Button variant="contained" onClick={this.start}>OK</Button>
                            </div>
                        }
                    </DialogActions>
                </Dialog>
                <Button variant="contained" onClick={this.showDialog}>{this.props.name}</Button>
            </div>
        );
    }
}

RemoteButton.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.any,
    onStart: PropTypes.func.isRequired,
};
